import { createReducer, on } from '@ngrx/store';
import { SustainabilityState, sustainabilityInitialState } from '../states/sustainability.state';
import { sustainabilityActions } from '../actions/sustainability.actions';

export const sustainabilityReducer = createReducer(
  sustainabilityInitialState,
  on(
    sustainabilityActions.setCarbonTrackError,
    (state, { error }): SustainabilityState => ({
      ...state,
      carbonTrack: {
        ...state.carbonTrack,
        error: error,
        data: null,
      },
    })
  ),
  on(
    sustainabilityActions.setCarbonTrackFilters,
    (state, { filters }): SustainabilityState => ({
      ...state,
      carbonTrack: {
        ...state.carbonTrack,
        filters: filters,
      },
    })
  ),
  on(
    sustainabilityActions.setCarbonTrackData,
    (state, { data }): SustainabilityState => ({
      ...state,
      carbonTrack: {
        ...state.carbonTrack,
        error: null,
        data: data,
      },
    })
  ),
  on(
    sustainabilityActions.setOriginWarrantyError,
    (state, { error }): SustainabilityState => ({
      ...state,
      originWarranty: {
        ...state.originWarranty,
        error: error,
        data: null,
      },
    })
  ),
  on(
    sustainabilityActions.setOriginWarrantyFilters,
    (state, { filters }): SustainabilityState => ({
      ...state,
      originWarranty: {
        ...state.originWarranty,
        filters: filters,
      },
    })
  ),
  on(
    sustainabilityActions.setOriginWarrantyData,
    (state, { data }): SustainabilityState => ({
      ...state,
      originWarranty: {
        ...state.originWarranty,
        error: null,
        data: data,
      },
    })
  ),
  // SUSTAINABILITY-SUMMARY
  on(
    sustainabilityActions.setSummaryCarbonTrackFilters,
    (state, { filters }): SustainabilityState => ({
      ...state,
      summaryCarbonTrack: {
        ...state.summaryCarbonTrack,
        filters: filters,
      },
    })
  ),
  on(
    sustainabilityActions.setSummaryCarbonTrackData,
    (state, { data }): SustainabilityState => ({
      ...state,
      summaryCarbonTrack: {
        ...state.summaryCarbonTrack,
        data: data,
      },
    })
  )
);
